import type { ChatTask } from "@/sdk/agent/chat";

import type { QueuedChatProps } from "./QueuedChat";

import { QueuedChat } from "./QueuedChat";

export interface ChatListProps extends Pick<QueuedChatProps, "onChatSelected"> {
    chats: ChatTask[];
    isSelectedChat: (chat: ChatTask) => boolean;
}

export function FlatChatList({ chats, onChatSelected, isSelectedChat }: ChatListProps) {
    /** Sort the chat tasks by whether they are wrapping */
    const sortedChatTasks = chats.sort(
        (task1, task2) => Number(task1.status === "wrapping") - Number(task2.status === "wrapping"),
    );

    const avatars = sortedChatTasks.map((chat: ChatTask) => {
        const isChatSelected = isSelectedChat(chat);

        return (
            <QueuedChat
                key={`chat-select-chatId:${chat.chatId}`}
                chat={chat}
                onChatSelected={onChatSelected}
                isChatSelected={isChatSelected}
            />
        );
    });

    return avatars;
}
